import React from 'react'
import Button from '@mui/material/Button'

const AddPolicy = ({ buttonText, setShowEditor, setShowAddButton }) => {
    return (
        <div
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                padding: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Button
                style={{ cursor: 'pointer' }}
                variant="contained"
                sx={{ marginRight: 2 }}
                onClick={() => {
                    setShowEditor(true)
                    setShowAddButton(false)
                }}
            >
                {buttonText}
            </Button>
        </div>
    )
}

export default AddPolicy
